<div class="oi-page-main">
    <div class="oi-main-dshd">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h2 class="bg-heading">Taskworks- {{Tags}}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
          <div class="task-work-tab">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a *ngIf="(role == 'admin' && temp_code !== 'SYSTASK') || (role == 'system admin' && temp_code == 'SYSTASK')"
 class="nav-link" [ngClass]="{'active': activeTab === 'task'}" (click)="setActiveTab('task')"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M13 5h8" /><path d="M13 9h5" /><path d="M13 15h8" /><path d="M13 19h5" /><path d="M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /><path d="M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /></svg> Properties</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': activeTab === 'execute'}" (click)="setActiveTab('execute')"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M4 17l5 1l.75 -1.5" /><path d="M15 21l0 -4l-4 -3l1 -6" /><path d="M7 12l0 -3l5 -1l3 3l3 1" /></svg> Execute</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': activeTab === 'log'}" (click)="setActiveTab('log')"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 12h.01" /><path d="M4 6h.01" /><path d="M4 18h.01" /><path d="M8 18h2" /><path d="M8 12h2" /><path d="M8 6h2" /><path d="M14 6h6" /><path d="M14 12h6" /><path d="M14 18h6" /></svg> Taskwork Log</a>
              </li>
            </ul>
          </div>
          </div>
        </div>
  
        <!-- Tabs Navigation -->
     
  
        <!-- Taskworks Tab -->
        <div *ngIf="activeTab === 'task' && (role=='admin'|| 'system admin')">
        
          <div class="oi-properties d-flex align-items-end flex-column">
            <div class="oipeop-top">
            <div class="row">
              <div class="col-md-6">
                <div class="oi-frm-task">             
                <input type="text" class="form-control" id="qns" [(ngModel)]="Tags" readonly>
                </div>
              </div>
              <div class="col-md-6">
                <div class="oi-frm-task" readonly>
                  <select name="cars" id="task" class="form-select">
                    <option value="Task">Task</option>
                    <option value="Prompt">Prompt</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="oi-frm-task">
                <input type="text" class="form-control" id="qns" [(ngModel)]="temp_code"  [readonly]="readonly">
                </div>
              </div>
            </div>
            <div class="oi-modifiy-txt">
              <div class="row">
                <div class="col-md-6"><div class="parameter-text">To Modify the response, change the default script</div></div>
                <div class="col-md-6">
                <div class="changescript-btn" *ngIf="!readonly">
                  <button type="button" class="btn change-script-btn" (click)="OpenScriptModal()" ><svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M8 9h8" /><path d="M8 13h6" /><path d="M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6" /><path d="M20 21l2 -2l-2 -2" /><path d="M17 17l-2 2l2 2" /></svg> Change Script</button>
                </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="oi-frm-task">
                <input type="text" class="form-control" id="qns" [(ngModel)]="template_purpose"  [readonly]="readonly">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div >
                  <div class="oi-taskword-editor">
                    <div *ngIf="!readonly">
                    <md-editor [(ngModel)]="prompt" [options]="editorOptions" [mode]="mode" [style]="{ height: '400px', width: '100%' }"></md-editor>
                  </div>
                  <div *ngIf="readonly" class="readonly-markdown-preview oi-readonly">
                    {{ prompt }}
                  </div>                  
                  </div>                        

                </div>
                <div *ngIf="prompt.length === 0 && submitted" class="validation-error">Prompt is required.</div>
              </div>
               
            </div>
            

            <div class="row" >
              <div class="col-md-12">
                <div class="oi-manage-parameter">
                  <div class="row d-flex justify-content-end">
                    <div class="col-md-6" *ngIf="params.length>0"><div class="parameter-text">Manage Parameters</div>
                    <div class="col-md-6">
                    <div class="para-rescan-btn">
                      <button type="button" class="btn rescan-btn" [disabled]="paramloading || readonly" (click)="onClickRescan(prompt)"><span *ngIf="paramloading"><i class="fa fa-spinner"></i></span><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg> Rescan</button>
                    </div>
                    </div>
                  </div>
                  </div>

                  <div class="row" *ngIf="params.length>0">
                    <div class="col-md-12">
                      <div class="oi-managepara-table">
                        <div class="table-responsive">
                          <table class="table" >
                           <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Label</th>
                           </tr>
                           <tr *ngFor="let param of params">
                            <td>{{param.name}}</td>
                            <td> <select class="form-select" [(ngModel)]="param.type" [disabled]="readonly">
                              <option *ngFor="let type of typeOptions" [value]="type">{{ type }}</option>
                            </select></td>
                            <td>
                              <input type="text" class="form-control" id="qns" [(ngModel)]="param.label" [readonly]="readonly">
                            </td>
                           </tr>                         
                         </table>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>


            </div>

            

            <div class="test-save-btn-mn mt-auto">
            <div class="test-save-relative">
            <div class="testsave-btn-mn1">
            
            <div class="row">
            <div class="col-md-12">
              <div class="test-save-btn">
              <button type="button" class="btn test-btn" [disabled]="!activateTestbtn || readonly" (click)="clicktoTest()"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M5.636 19.364a9 9 0 1 1 12.728 0" /><path d="M16 9l-4 4" /></svg> Test</button>
              <button type="button" class="btn save-changes" [disabled]="saveTemp || readonly"  (click)="saveTemplateChanges()"> <span *ngIf="saveTemp"><i class="fa fa-spinner"></i></span><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" /><path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M14 4l0 4l-6 0l0 -4" /></svg> Save Changes</button>
            </div>
            </div>
            </div>

            </div>
            </div>
            </div>

          </div>

          </div>



        <div *ngIf="activeTab === 'execute'">
          <div class="excute-main-tab">
            <div class="row">
            
              <div class="col-md-12">
                <div class="ex-inner-tab-txt">{{template_purpose}}</div>
              </div>
            </div>
          <div *ngIf="params.length>0">
            <div class="row">
              <div class="col-md-12">
                <div class="excute-parameter-heading">Parameters</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" *ngFor="let param of params">
                <div class="num-para-fld">
                <label>{{ param.label }}</label>
                <input *ngIf="param.type === 'int'" type="number" [(ngModel)]="param.value" class="tsk-field3" />
                <input *ngIf="param.type === 'text'" type="text" [(ngModel)]="param.value" placeholder="question type" class="number-field1" />
                <p-calendar *ngIf="param.type === 'date'" [(ngModel)]="param.value" [dateFormat]="'dd MM yy'" placeholder="date"></p-calendar>

                <div class="oi-task-excu-search d-flex justify-content-between"  *ngIf="param.type === 'search'">
                  <div class="oi-ex-search-mn d-flex">
                    <div class="oi-task-esearch-bx">
                  <p-autoComplete [(ngModel)]="param.displayText" [suggestions]="param.filteredQuestions" 
                  (completeMethod)="searchQuestions($event, param)"   (onSelect)="onQuestionSelect($event, param)"
                  (keyup.enter)="searchQuestions($event, param)"  field="question" placeholder="Type a question to remap the answer..." 
                  >
                  <ng-template let-question pTemplate="item">
                      <div [innerHTML]="question.question | highlight:param.value"></div>
                    </ng-template>
              </p-autoComplete>
                 <div *ngIf="submitted && (!param.displayText || param.displayText.trim() === '')" class="validation-error">
                  Question is required.
                  </div>
                    </div>
              
              <div class="oi-ex-searc-btnm"><button type="button" class="btn" (click)="searchQuestions($event, param)"><img src="../../assets/img/search1.svg"></button></div>

              </div>
              <div class="oi-excu-drop">
                <p-dropdown [options]="availableCollections" [(ngModel)]="selectedCollection" optionLabel="collectionName" optionValue="collectionName" placeholder="Select a Collection" (onChange)="changeCollection($event)"></p-dropdown>
              </div>
                </div>
              </div>
            </div>
              
            </div>
          </div> 

            <div class="row">
              <div class="col-md-12">
                <div class="excute-editor">
                  <md-editor [(ngModel)]="taskContent" [options]="editorOptions" [mode]="mode" [style]="{ height: '400px', width: '100%' }"></md-editor>
                </div>
              </div>
              <div *ngIf="taskContent.length === 0 && submitted" class="validation-error">Task Content is required.</div>

            </div>
                      
                 
                    <div class="excute-response-heading1">Responses</div> 
                    
            <div class="row">
              <div class="col-md-12">
                <div class="excute-bx1">
                  <div class="oi-task-wk-gen-mn">
                    <div class="oi-tw-gen-multi-btn">
                        <div class="button-container">
                            <button class="btn btn-primary" (click)="downloadContent(responseData)" pTooltip="download">
                               <img src="../assets/img/download2.svg">
                            </button>
                            <button class="btn btn-primary" (click)="copyContent(responseData)" pTooltip="copy">
                                <img src="../assets/img/copy2.svg">
                                <span *ngIf="isCopied" class="copied-message">Copied to clipboard!</span>
                            </button>
                            <button class="btn btn-primary" (click)="toggleFullScreen()" pTooltip="expand" tooltipPosition="top">
                                <img src="../assets/img/{{ isExpanded ? 'minimize' : 'maximize' }}2.svg">
                            </button>
                        </div>
                    </div>
                    <div class="oi-tw-genrate-text" [ngClass]="{'maximized': isExpanded}" [ngStyle]="{'height': isExpanded ? 'auto' : '100px'}" >
                      <div class="chat-list">
                        <div class="params-bx1" *ngFor="let entry of responseData">
                          <ng-container *ngIf="entry.params">
                            <h4>Params: {{ entry.params }}</h4>
                          </ng-container>                      
                          <div class="para-details" [innerHTML]="entry.response"></div>
                        </div>
                      </div>
                      
                    </div>
                </div>
                </div>
              </div>
            </div>
            <button class="btn btn btn-primary excute-btn1" (click)="generateResponse()" [disabled]="isloading" [ngClass]="{ 'disabled-button': isloading }"><span *ngIf="isloading"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M12 6l0 -3" /><path d="M16.25 7.75l2.15 -2.15" /><path d="M18 12l3 0" /><path d="M16.25 16.25l2.15 2.15" /><path d="M12 18l0 3" /><path d="M7.75 16.25l-2.15 2.15" /><path d="M6 12l-3 0" /><path d="M7.75 7.75l-2.15 -2.15" /></svg> </span>Execute</button>


          </div>
        </div>
  
        <!-- Taskwork Log Tab -->
        <div *ngIf="activeTab === 'log'">

          <div class="task-work-log">
            <div class="row">
              <div class="col-md-8">
                <div class="excut-search-dld d-flex">
                  <div class="search-exc-mn d-flex">
                    <input type="text" class="form-contro1" placeholder="Search..." [(ngModel)]="searchTerm" 
                    (input)="filterLogs()">
                    <button type="button" class="search-ex-btn">
                      <svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
                    </button>
                  </div>

                  <div class="search-exc-dow-btn">
                  <div class="search-exc-dow-inner">
                    <button class="refre-search-btn"  (click)="refreshLogpage()" pTooltip="Refresh">
                      <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg>
                    </button>
                    <button type="button" class="down-search-btn" pTooltip="Download" [ngClass]="{ 'disabled-button': dLoader }" (click)="downloadLog()">
                      <span *ngIf="dLoader"><i class="fa fa-spinner fa-spin"></i> 
                      </span><svg  *ngIf="!dLoader" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg></button>
                  </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
              <div class="date-filtermn d-flex">
               <div class="task-calendrftr"> <p-calendar 
  [(ngModel)]="selectedDateRange" 
  selectionMode="range" 
  [showIcon]="true"
  placeholder="Select Date Range"
  placeholder="Select Date Range"
  (onSelect)="handleDateSelection()">
</p-calendar>
</div>

                <div class="date-bx2">
                <div class="date-bx2-inn">
                  <div class="date-filter-btn" (click)="fetchtaskworkLogs()"><button class="filter-btn">Filter</button></div>
                  
                </div>
                </div>
                
                
                
                
               


              </div>
              </div>

            </div>     
          
           
          
            <div class="row">
              <div class="col-md-12">
              <div class="task-work-log-table" *ngIf="!loader else loading">
                <div class="table-responsive">
                  <table class="table table-bordered">
                      <thead class="table-light">
                          <tr >
                              <th>Created On</th>
                              <th>Request</th>
                              <th>AI Response</th>
                              <th>Template</th>
                              <th>Parameters</th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let log of filteredTaskLog; let i = index">
                          <td [innerHTML]="highlightText(formatcreateDate(log.created_at ) || '')"></td>
                          <td (click)="openModal(log.req_content, 'req_content')" class="td-hover1">
                            <div class="log-content-table">
                              <div class="logs-text-ecl" [innerHTML]="highlightText(log.req_content)"></div>
                            </div>
                          </td>
                          <td (click)="openModal(log.ai_content_response, 'ai_content_response')" class="td-hover1">
                            <div class="log-content-table">
                              <div class="logs-text-ecl" [innerHTML]="highlightText(log.ai_content_response)"></div>
                            </div>
                          </td>
                          <td [innerHTML]="highlightText(log.template_code)"></td>
                          <td [innerHTML]="highlightText(log.template_params | json)"></td>
                        </tr>
                        
                          <tr *ngIf="filteredTaskLog.length === 0">
                            <td colspan="9" class="text-center">No logs available</td>
                          </tr>
                      </tbody>
                  </table>
                  <div *ngIf="filteredTaskLog.length>0">
                    <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                        [totalRecords]="totalrecords"></p-paginator>
                </div>
              </div>
              </div>
              </div>
            </div>
            <ng-template #loading>
              <div class="imgloader">
                  <img src="../../assets/img/loader.gif">
              </div>
          </ng-template>
          </div>


       
        </div>
  
      </div>
    </div>
  </div>
  <p-dialog class="modal-front" [(visible)]="openScriptmodal"  [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    [maximizable]="true"  (onHide)="onDialogHideaddcollection()" (onShow)="showDialog()">
    
    <ng-template pTemplate="header">
      <div class="p-dialog-titlebar changescript-hd1">
          <span class="p-dialog-title">{{ dialogTitle }}</span>
          <div class="p-dialog-titlebar-icons oi-iconscript">
            <span *ngIf="isCopied" class="copied-message9">Copied to clipboard!</span>
              <button class="p-dialog-titlebar-icon p-link" (click)="copyToClipboard()">
                <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
              </button> 
              
          </div>
      </div>
  </ng-template>
    <div class="oi-ad-collect-mdl khdoc">
            <div class="modal-content documnttext">
                <div class="modalcustome-height" >
                </div>
                <ngx-codemirror
                #codeEditor
                [(ngModel)]="template_script"
                [options]="options"
              ></ngx-codemirror>
               
            </div>
            <div class="modal-footer mdl-footer"> 
               
              <button class="btn close-btn" (click)="closeScript()">Close</button>
              <button class="btn revert-btn" (click)="revrtScript()" [disabled]="updatescript">Revert Default</button>
              <button class="btn save-btn"  (click)="updateScript()"> <span *ngIf="updatescript"><i class="fa fa-spinner"></i></span>update</button>            
            </div>
    </div>
    

</p-dialog>
<p-dialog [(visible)]="openlogModal"  [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onDialogHideaddcollection()">
    <ng-template pTemplate="header">
      <div class="p-dialog-titlebar changescript-hd1">
          <span class="p-dialog-title">{{ aidialogTitle }}</span>
          <div class="p-dialog-titlebar-icons oi-iconscript">
            <span *ngIf="islogCopied" class="copied-message9">Copied to clipboard!</span>
              <button class="p-dialog-titlebar-icon p-link" (click)="copylogToClipboard()">
                <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
              </button> 
              
          </div>
      </div>
  </ng-template>
    <div class="oi-ad-collect-mdl khdoc">
            <div class="modal-content documnttext">                
                <div>
                    <div [innerHTML]="sanitizeMessage(selectedAILogContent)"></div>
                </div>           
            </div>         
    </div>
    

</p-dialog>
<p-toast></p-toast>
  